module.exports = __webpack_public_path__ + "static/media/Single Check.7a13ff43.svg";